import { render, staticRenderFns } from "./ViewDetailShortSentences.vue?vue&type=template&id=0ce862c0&scoped=true&"
import script from "./ViewDetailShortSentences.vue?vue&type=script&lang=js&"
export * from "./ViewDetailShortSentences.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailShortSentences.vue?vue&type=style&index=0&id=0ce862c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce862c0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
